module.exports = __webpack_public_path__ + "media/40.f362f4c0.mp3";